<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <div class="d-flex justify-end">
          <v-btn @click="openCreateModal" color="primary" elevation="0">
            <v-icon left>mdi-plus</v-icon>
            <span class="d-none d-md-flex body-2">
              {{ $t(`hausefulUsers.action.create`) }}
            </span>
          </v-btn>
        </div>
      </template>
    </h-header>

    <v-card outlined>
      <v-data-table
        @dblclick:row="showServiceProviderUserRow"
        :loading-text="$t('appointment.table.loading')"
        :no-data-text="$t('appointment.table.noData')"
        :items="serviceProviderUsers"
        :items-per-page="30"
        :loading="isServiceProviderLoading"
        :headers="headers"
        mobile-breakpoint="20"
        class="clickable"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
          <span class="d-block caption grey--text">
            {{ item.email }}
          </span>
        </template>
        <template v-slot:[`item.active`]="{ item }">
          {{ status(item.active) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <ServiceProviderUserListMenu :serviceProviderUser="item" />
        </template>
      </v-data-table>
      <h-pagination :fetch="listServiceProviderUsers" />
    </v-card>
    <CreateUpdateServiceProviderUser />
    <ServiceProviderUserDetails />
    <RemoveServiceProviderUser />
  </div>
</template>

<script>
// vue core
import { mapActions, mapMutations, mapGetters } from 'vuex'

// ui
import { serviceProviderUserHeaders } from '../listHeaders'

// fragments
import ServiceProviderUserListMenu from '../fragments/ServiceProviderUserListMenu.vue'
import ServiceProviderUserDetails from '../fragments/ServiceProviderUserDetails.vue'

// modals
import CreateUpdateServiceProviderUser from '../modals/CreateUpdateServiceProviderUser.vue'
import RemoveServiceProviderUser from '../modals/RemoveServiceProviderUser.vue'

export default {
  name: 'ServiceProviderUsersList',

  components: {
    CreateUpdateServiceProviderUser,
    ServiceProviderUserListMenu,
    ServiceProviderUserDetails,
    RemoveServiceProviderUser,
  },

  computed: {
    ...mapGetters(['isServiceProviderLoading', 'serviceProviderUsers']),
  },

  methods: {
    ...mapActions(['openModal', 'listServiceProviderUsers', 'showServiceProviderUser']),
    ...mapMutations(['setIsDrawerOpen']),

    status(status) {
      return status ? this.$t('defaultServiceValues.label.active') : this.$t('defaultServiceValues.label.inactive')
    },

    openCreateModal() {
      this.openModal('CREATE_UPDATE_SERVICE_PROVIDER_USER')
    },

    showServiceProviderUserRow(_, { item }) {
      if (!item) return
      this.setIsDrawerOpen(true)
      this.showServiceProviderUser(item.id)
    },
  },

  data() {
    return {
      headers: serviceProviderUserHeaders,
    }
  },

  mounted() {
    this.listServiceProviderUsers()
  },
}
</script>
